import { render, staticRenderFns } from "./ReportSideBar.vue?vue&type=template&id=70b14d92"
import script from "./ReportSideBar.vue?vue&type=script&lang=js"
export * from "./ReportSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports